import React from 'react';
import AttributeTable from './AttributeTable';
import Modals from './Modals';

const Attributes = () => {
  // AttributeTable manages its own loading/state; parent keeps UI and modal state only
  const [expanded, setExpanded] = React.useState({});

  const [showModal, setShowModal] = React.useState(false);
  // Term modal state (context only; form handled inside modal)
  const [showTermModal, setShowTermModal] = React.useState(false);
  const [termModalContext, setTermModalContext] = React.useState({ taxonomy: '', type: 'select' });
  // Edit modal state (edit target only; form handled inside modal)
  const [showEditModal, setShowEditModal] = React.useState(false);
  const [editTargetTerm, setEditTargetTerm] = React.useState(null);

  // AttributeTable now owns fetching. Parent provides a refresh trigger.
  const [refreshCounter, setRefreshCounter] = React.useState(0);
  const triggerRefresh = React.useCallback(() => setRefreshCounter((c) => c + 1), []);

  const toggle = (taxonomy) => {
    setExpanded((s) => ({ ...s, [taxonomy]: !s[taxonomy] }));
  };

  // Modal form state
  const [formState, setFormState] = React.useState({
    name: '',
    type: 'select',
  });

  const openModal = () => {
    setFormState({ name: '', type: 'select' });
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const handleField = (k, v) => setFormState((s) => ({ ...s, [k]: v }));

  const openTermModal = (taxonomy, type) => {
    setTermModalContext({ taxonomy: taxonomy || '', type: type || 'select' });
    setShowTermModal(true);
  };

  const closeTermModal = () => setShowTermModal(false);

  const openMediaLibrary = (onSelect) => {
    if (typeof window.wp === 'undefined' || !window.wp.media) {
      return;
    }
    const frame = window.wp.media({ title: 'Select or Upload Image', library: { type: 'image' }, multiple: false });
    frame.on('select', function () {
      const attachment = frame.state().get('selection').first().toJSON();
      onSelect(attachment.url || attachment.sizes?.full?.url || '');
    });
    frame.open();
  };
  // term create handled inside AddTermModal

  // Edit modal helpers
  const openEditModal = (term, type, taxonomy) => {
    setEditTargetTerm({
      term_id: term.term_id || 0,
      taxonomy: taxonomy || term.taxonomy || '',
      name: term.name || '',
      slug: term.slug || '',
      description: term.description || '',
      color: (term.meta && term.meta.color) ? term.meta.color : '#0000ff',
      image: (term.meta && term.meta.image) ? term.meta.image : '',
      type: type || 'select',
      select: (term.meta && term.meta.select) ? term.meta.select : '',
    });
    setShowEditModal(true);
  };

  const closeEditModal = () => setShowEditModal(false);

  // edit term handled inside EditTermModal

  // attribute create handled inside AddAttributeModal

  // Attribute edit modal target (full form handled inside EditAttributeModal)
  const [showEditAttributeModal, setShowEditAttributeModal] = React.useState(false);
  const [attributeTarget, setAttributeTarget] = React.useState(null);

  const openEditAttributeModal = (attr) => {
    setAttributeTarget(attr || null);
    setShowEditAttributeModal(true);
  };

  const closeEditAttributeModal = () => setShowEditAttributeModal(false);

  // AttributeTable handles loading and error UI

  return (
    <div className="tpv-attributes-page bg-gray rounded-3xl px-[1rem] sm:px-[1.5rem] md:px-[2.725rem] lg:px-[50px] xl:px-[80px] pb-[62px] py-11 h-full">
      <h3 className="text-2xl font-medium mb-4">WooCommerce Attributes</h3>
      <AttributeTable
        expanded={expanded}
        toggle={toggle}
        openModal={openModal}
        openTermModal={openTermModal}
        openEditModal={openEditModal}
        openAttributeEditModal={openEditAttributeModal}
        refreshCounter={refreshCounter}
      />
      <Modals
        showModal={showModal}
        closeModal={closeModal}
        triggerRefresh={triggerRefresh}
        showTermModal={showTermModal}
        closeTermModal={closeTermModal}
        termModalContext={termModalContext}
        showEditModal={showEditModal}
        closeEditModal={closeEditModal}
        editTargetTerm={editTargetTerm}
        showEditAttributeModal={showEditAttributeModal}
        closeEditAttributeModal={closeEditAttributeModal}
        attributeTarget={attributeTarget}
        openMediaLibrary={openMediaLibrary}
      />
    </div>
  );
};

export default Attributes;
